import {createSlice, createAsyncThunk} from '@reduxjs/toolkit'
import {
  onGetPagedAllGraduatedCards,
  onCreateGraduatedCard,
  onDeleteGraduatedCard,
  onGetGraduatedCard,
  onUpdateGraduatedCard,
  onUpdateGraduatedCardStatus,
  onGetGraduatedCardByGraduatedId,
} from '../../../app/modules/graduation-system/components/graduates/component/graduated-card/core/_requests'
import {
  onGetGraduates,
  onGetCardStatuses,
  onGetDeliveryTypes,
} from '../../../app/services/dataForComboBox/dataForComboBoxService'
interface GraduatedCardState {
  graduatedCards: any
  graduatedCard: any
  graduates: any
  cardStatuses: any
  deliveryTypes: any
  isLoading: boolean
}
const initialState = {
  graduatedCards: [],
  graduatedCard: null,
  graduates: [],
  cardStatuses: [],
  deliveryTypes: [],
  isLoading: true,
} as GraduatedCardState

export const fetchGraduates = createAsyncThunk('graduatedCard/fetchGraduates', async () => {
  const data: any = await onGetGraduates()
  return data.data.result
})

export const fetchCardStatuses = createAsyncThunk('graduatedCard/fetchCardStatuses', async () => {
  const data: any = await onGetCardStatuses()
  return data.data.result
})

export const fetchDeliveryTypes = createAsyncThunk('graduatedCard/fetchDeliveryTypes', async () => {
  const data: any = await onGetDeliveryTypes()
  return data.data.result
})

export const fetchGraduatedCards = createAsyncThunk(
  'graduatedCard/fetchGraduatedCards',
  async (param: any) => {
    const data: any = await onGetPagedAllGraduatedCards(param)
    return data.data.result
  }
)

export const fetchGraduatedCardsByGraduatedId = createAsyncThunk(
  'graduatedCard/fetchGraduatedCardsByGraduatedId',
  async (param: any) => {
    const data: any = await onGetGraduatedCardByGraduatedId(param)
    return data.data.result
  }
)

export const fetchGraduatedCard = createAsyncThunk(
  'graduatedCard/fetchGraduatedCard',
  async (param: any) => {
    const data: any = await onGetGraduatedCard(param)
    return data.data.result
  }
)

export const updateGraduatedCard = createAsyncThunk(
  'graduatedCard/updateGraduatedCard',
  async (param: any) => {
    const data: any = await onUpdateGraduatedCard(param)
    return data.data
  }
)

export const updateGraduatedCardStatus = createAsyncThunk(
  'graduatedCard/updateGraduatedCardStatus',
  async (param: any) => {
    const data: any = await onUpdateGraduatedCardStatus(param)
    return data.data
  }
)

export const createGraduatedCard = createAsyncThunk(
  'graduatedCard/createGraduatedCard',
  async (param: any) => {
    const data: any = await onCreateGraduatedCard(param)
    return data.data
  }
)

export const deleteGraduatedCard = createAsyncThunk(
  'graduatedCard/deleteGraduatedCard',
  async (param: any) => {
    const data: any = await onDeleteGraduatedCard(param)
    return data.data
  }
)

const graduatedCardSlice = createSlice({
  name: 'graduatedCard',
  initialState,
  reducers: {
    clearGraduatedCards: (state) => {
      state.graduatedCards = []
    },
    clearGraduatedCard: (state) => {
      state.graduatedCard = null
    },
    activateLoading: (state) => {
      state.isLoading = true
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchGraduatedCards.pending, (state: any) => {
      state.isLoading = true
    })
    builder.addCase(fetchGraduatedCards.fulfilled, (state: any, action) => {
      state.graduatedCards = action.payload
      state.isLoading = false
    })
    builder.addCase(fetchGraduatedCards.rejected, (state: any) => {
      state.isLoading = false
    })

    builder.addCase(fetchGraduatedCardsByGraduatedId.pending, (state: any) => {
      state.isLoading = true
    })
    builder.addCase(fetchGraduatedCardsByGraduatedId.fulfilled, (state: any, action) => {
      state.graduatedCards = action.payload
      state.isLoading = false
    })
    builder.addCase(fetchGraduatedCardsByGraduatedId.rejected, (state: any) => {
      state.isLoading = false
    })
    builder.addCase(fetchGraduatedCard.fulfilled, (state: any, action) => {
      state.graduatedCard = action.payload
    })
    builder.addCase(fetchGraduates.fulfilled, (state: any, action) => {
      state.graduates = action.payload.items
    })
    builder.addCase(fetchCardStatuses.fulfilled, (state: any, action) => {
      state.cardStatuses = action.payload.items
    })
    builder.addCase(fetchDeliveryTypes.fulfilled, (state: any, action) => {
      state.deliveryTypes = action.payload.items
    })
  },
})

export const {clearGraduatedCards, clearGraduatedCard, activateLoading} = graduatedCardSlice.actions

export default graduatedCardSlice.reducer
